<template>
  <v-container>
    <v-layout>
      <v-flex wrap xs12 sm8 offset-sm-2 md6 offset-md-3 lg4 offset-lg-4>
        <v-toolbar v-if="isLoggedIn" flat>
          <v-toolbar-title>Account</v-toolbar-title>
        </v-toolbar>
        <h1
          v-else
          class="display-2 font-weight-bold mb-3 text-center primary--text"
        >
          Arrival Subscriptions
        </h1>
        <v-layout
          :column="$vuetify.breakpoint.xs"
          justify-center
          align-center
          mb-4
        >
          <template v-if="isLoggedIn">
            <div class="text-center py-3 mt-2" style="width: 100%">
              <v-avatar color="accent">
                <v-icon dark>mdi-account</v-icon>
              </v-avatar>
              <div class="text-h6 text-capitalize mt-2">
                {{ user.name }}
              </div>
              <div class="text-body-1 text-lowercase">
                {{ user.email }}
              </div>
              <v-list class="mt-3">
                <v-list-item
                  class="secondary--text text-left"
                  :to="{ name: 'Home' }"
                >
                  <v-list-item-content>
                    <v-list-item-title>Manage subscriptions</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </template>
          <template v-else>
            <v-btn solid color="secondary" to="/login" width="200" class="ma-2">
              Log in now
            </v-btn>
            <v-btn
              solid
              color="primary"
              to="/register"
              width="200"
              class="ma-2"
            >
              Create an account
            </v-btn>
          </template>
        </v-layout>
        <p>
          If you regularly commute using our transit system, you can get
          notifications when a bus/ferry/train is approaching the stop you
          usually board at, at the times when you need.
        </p>
        <p>
          To begin, navigate to your stop on
          <a target="_parent" href="/rtt/public/transit.aspx?page=map">
            our map
          </a>
          <br />
          If you are a mobile user, simply long press on the stop or station
          <br />
          If you are on a larger device, when you open a stop's ETA box, click
          on the glowing <v-icon color="secondary">add_box</v-icon>
        </p>
        <v-img src="@/assets/add_sub_help.png" class="my-3 rounded" />
        <v-list v-if="isLoggedIn">
          <v-list-item class="error--text" :to="{ name: 'DeleteAccount' }">
            <v-list-item-content>
              <v-list-item-title>Delete account</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="error">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    user() {
      return this.$store.state.user;
    },
    isLoggedIn() {
      return this.$store.state.loggedIn;
    },
  },
};
</script>
